module.exports = __webpack_public_path__ + "static/logo-d03b9ae6a3ab48eea6722cc8d7d24d51.svg";